import './../Signup.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import update from "immutability-helper";

import { clearUser, postPutUser, setUser } from 'containers/Accounts/store/actions';

import A from 'components/A';
import Button from 'components/Button';
import FreelancerSignupForm from './FreelancerSignupForm';
import Modal from 'components/Modal';
import PageContent from 'components/PageContent';

class FreelancerSignupPage extends React.Component {
    constructor() {
        super();

        this.state = {
            showSuccessModal: false
        };
    }
    componentDidMount() {
        document.body.classList.add('auth-page');
        document.body.classList.add('signup-page');
    }

    componentWillUnmount() {
        document.body.classList.remove('auth-page');
        document.body.classList.remove('signup-page');
    }

    handleChange(name, value) {
        let newUserObj = update(this.props.accounts.user, {});
        newUserObj[name] = value;
        this.props.setUser(newUserObj);
    }

    handleSubmit() {
        return new Promise((resolve) => {
            this.props.postPutUser()
                .then((res) => {
                    this.props.clearUser();
                    this.setState({showSuccessModal: true});
                    resolve(res);
                })
        });
    }

    render() {
        return (
            <PageContent className="signup-content">
                <div className="signup-form--wrapper auth-form--wrapper">
                    <FreelancerSignupForm
                        error={this.props.accounts.error}
                        handleChange={this.handleChange.bind(this)}
                        isSaving={this.props.accounts.isSavingUser}
                        handleSubmit={this.handleSubmit.bind(this, true)}
                        user={this.props.accounts.user}
                    />

                    <div className="auth-page__links">
                        Already have an account? <A to="/login">Login</A>
                    </div>
                </div>

                <Modal show={this.state.showSuccessModal === true}
                       title="Success!">
                    <p>
                        Success!
                    </p>
                    <p>
                        Your user account is created. You'll now be redirected to your user profile.
                    </p>
                    <div className="c-modal__button-wrapper">
                        <Button onClick={() => {
                            this.setState({showSuccessModal: false});
                            this.props.changeLocation('/account/profile');
                        }}>
                            OK
                        </Button>
                    </div>
                </Modal>
            </PageContent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        accounts: state.accounts,
        auth: state.auth
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        clearUser: () => dispatch(clearUser()),
        postPutUser: () => dispatch(postPutUser()),
        setUser: (invitationDataObj) => dispatch(setUser(invitationDataObj))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(FreelancerSignupPage);



// WEBPACK FOOTER //
// ./src/containers/Auth/Signup/FreelancerSignupPage/index.js